import { render, staticRenderFns } from "./alertcalendar.vue?vue&type=template&id=26390404"
import script from "./alertcalendar.vue?vue&type=script&lang=js"
export * from "./alertcalendar.vue?vue&type=script&lang=js"
import style0 from "./alertcalendar.vue?vue&type=style&index=0&id=26390404&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports